/**
 * Custom branded icons for the 3 strategic navbar pills.
 * - IconPalace  : Classical Italian palace facade (columns + pediment) — ISTITUZIONI
 * - IconNetwork : 5 nodes connected like a constellation — RETE DEI COMUNI
 * - IconSeal    : Ornate medallion / wax seal with star — BANDI & FINANZIAMENTI
 *
 * All icons use `currentColor` so they inherit the pill's text color.
 * Designed at 16×16 base for tight nav use; scalable via className w-X.
 */

export const IconPalace = ({ className = 'w-4 h-4', strokeWidth = 1.8 }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {/* Pediment */}
    <path d="M3 9L12 4l9 5" />
    <path d="M4 9h16" />
    {/* Columns */}
    <line x1="6.5" y1="9" x2="6.5" y2="18" />
    <line x1="10" y1="9" x2="10" y2="18" />
    <line x1="14" y1="9" x2="14" y2="18" />
    <line x1="17.5" y1="9" x2="17.5" y2="18" />
    {/* Base */}
    <path d="M3 18h18" />
    <path d="M2.5 20.5h19" strokeWidth={strokeWidth * 1.1} />
  </svg>
);

export const IconNetwork = ({ className = 'w-4 h-4', strokeWidth = 1.8 }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {/* Connection lines */}
    <line x1="12" y1="12" x2="5" y2="5" />
    <line x1="12" y1="12" x2="19" y2="5" />
    <line x1="12" y1="12" x2="5" y2="19" />
    <line x1="12" y1="12" x2="19" y2="19" />
    {/* Central hub (filled) */}
    <circle cx="12" cy="12" r="2.2" fill="currentColor" stroke="none" />
    {/* Outer nodes */}
    <circle cx="5" cy="5" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="19" cy="5" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="5" cy="19" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="19" cy="19" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

export const IconSeal = ({ className = 'w-4 h-4', strokeWidth = 1.6 }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {/* Outer scalloped circle (medallion edge) */}
    <circle cx="12" cy="12" r="9" />
    {/* Inner ring */}
    <circle cx="12" cy="12" r="6.5" strokeWidth={strokeWidth * 0.7} />
    {/* Central star (5-pointed) — filled */}
    <path d="M12 7.5l1.5 3.1 3.4.5-2.5 2.4.6 3.4L12 15.3l-3 1.6.6-3.4-2.5-2.4 3.4-.5z" fill="currentColor" stroke="none" />
    {/* Ribbon hints below */}
    <path d="M9 19.5l1.5 2.5 1.5-1.8 1.5 1.8 1.5-2.5" strokeWidth={strokeWidth * 0.9} />
  </svg>
);
